import React, { PureComponent } from 'react';
import { css } from 'emotion';

import { TextBlock, CustomBlock } from './../../common';
import RedBridge from './../images/our_platform.jpg';
import { aboutUs as content } from './../content';
import EcoSystem from './ecoSystem/ecoSystem.component.js';

export default class AboutUs extends PureComponent {
    constructor() {
        super();
    }

    render() {
        return (
            <section id="aboutUs" className={s.wrapper}>
                <TextBlock
                    {...{
                        heading: content.aboutUs.heading,
                        text: content.aboutUs.content,
                        order: 1,
                    }}
                />
                <CustomBlock
                    {...{
                        component: <EcoSystem />,
                        order: 2,
                    }}
                />
            </section>
        );
    }
}

const s = {};

s.wrapper = css`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;



// WEBPACK FOOTER //
// ./src/components/sections/aboutUs/aboutUs.component.js